import {styled} from '@mui/material';

const TagChip = styled('span')`
	color: #0b4627 !important;
	background-color: #c2f5da;
	width: fit-content;
	padding: 2px 8px;
	border-radius: 999px;
	font-size: 0.75rem;
	font-weight: 600;
	display: flex;
	align-items: center;
	gap: 4px;
	margin-right: auto;
`;

export {TagChip};
